import React from "react";

const ResponsiveCellphonePage: React.FC = () => {
    return (
        <div className="flex flex-col h-screen">
            <main className="bg-black flex-1 overflow-auto">
                <div className="text-white text-center text-2xl font-bold h-full flex items-center justify-center">
                    working in progress, this wont have some features for now
                </div>
            </main>
        </div>
    );
};

export default ResponsiveCellphonePage;